import React from 'react';
import {RFValue} from 'react-native-responsive-fontsize';

import BottomSheet from '../../Interface/BottomSheet';
import {
  Container,
  GhostButton,
  GhostButtonText,
  HeaderIcon,
  IconCircle,
  PrimaryButton,
  PrimaryButtonText,
  Subtitle,
  Title,
} from './styles';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onWantToKnowMore: () => void;
}

export function FinesReminderModal({isOpen, onClose, onWantToKnowMore}: Props) {
  return (
    <BottomSheet isOpen={isOpen} onClose={onClose}>
      <Container>
        <IconCircle>
          <HeaderIcon name="car" size={RFValue(28)} />
        </IconCircle>
        <Title>Parcele multas e débitos veiculares</Title>
        <Subtitle>
          Sabia que aqui no app você também pode parcelar multas e débitos do
          seu veículo, sem sair do lugar onde já compra combustível?
        </Subtitle>

        <PrimaryButton onPress={onWantToKnowMore} activeOpacity={0.85}>
          <PrimaryButtonText>Quero saber mais</PrimaryButtonText>
        </PrimaryButton>

        <GhostButton onPress={onClose} activeOpacity={0.7}>
          <GhostButtonText>Agora não</GhostButtonText>
        </GhostButton>
      </Container>
    </BottomSheet>
  );
}
